var _g, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackToTop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 59,
    viewBox: "0 0 60 59",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_11386_36312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 48C16.7643 48 6 37.2357 6 24C6 10.7643 16.7643 0 30 0C43.2357 0 54 10.7643 54 24C54 37.2357 43.2357 48 30 48ZM30 4.08511C19.0213 4.08511 10.0851 13.0213 10.0851 24C10.0851 34.9787 19.0213 43.9149 30 43.9149C40.9787 43.9149 49.9149 34.9787 49.9149 24C49.9149 13.0213 40.9787 4.08511 30 4.08511Z",
    fill: "#01A1BD"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.9994 45.9569C42.1262 45.9569 51.9569 36.1262 51.9569 23.9994C51.9569 11.8727 42.1262 2.04199 29.9994 2.04199C17.8727 2.04199 8.04199 11.8727 8.04199 23.9994C8.04199 36.1262 17.8727 45.9569 29.9994 45.9569Z",
    fill: "#01A1BD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 48C16.7643 48 6 37.2357 6 24C6 10.7643 16.7643 0 30 0C43.2357 0 54 10.7643 54 24C54 37.2357 43.2357 48 30 48ZM30 4.08511C19.0213 4.08511 10.0851 13.0213 10.0851 24C10.0851 34.9787 19.0213 43.9149 30 43.9149C40.9787 43.9149 49.9149 34.9787 49.9149 24C49.9149 13.0213 40.9787 4.08511 30 4.08511Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4403 27.7162L29.9994 13.2754L15.5586 27.7162L18.4488 30.6065L29.9994 19.0558L41.5501 30.6065L44.4403 27.7162Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_11386_36312",
    x: 0.893617,
    y: 0,
    width: 58.2128,
    height: 58.2128,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.10638
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.55319
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11386_36312"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11386_36312",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackToTop);
export default __webpack_public_path__ + "static/media/BackToTop.a15e236d1d422738c7f7511bcccff70b.svg";
export { ForwardRef as ReactComponent };